import React from 'react';
import { useTranslation } from 'react-i18next';
import ArrowButton from '../../components/arrowButton';
import PageTitle from '../../components/pageTitle';
import { useApplicationForm } from '../../contexts/ApplicationFormContext';
import { getLanguageFontWithFallback } from '../../utils/fontUtils';
import './index.css';
import './index.tablet.css';
import './index.mobile.css';

function ApplyInfo() {
  const { t, i18n } = useTranslation();
  const currentLang = i18n.language || 'zh';
  const { openApplicationForm } = useApplicationForm();

  const highlightText = (text, highlight) => {
    if (!highlight) return text;
    const parts = text.split(highlight);
    if (parts.length === 1) return text;
    
    return parts.map((part, index) => (
      <React.Fragment key={index}>
        {part}
        {index < parts.length - 1 && <span className="highlight-text">{highlight}</span>}
      </React.Fragment>
    ));
  };

  // 云朵背景图路径
  const cloudBgUrl = `${process.env.PUBLIC_URL}/image/云朵背景.jpg`;

  return (
    <div className="apply-info-container">
      <div 
        className="apply-info-cloud-bg"
        style={{
          backgroundImage: `url(${cloudBgUrl})`
        }}
      />
      <div className="apply-info-section-container">
        <PageTitle marginBottom="53px">
          <span style={{ fontFamily: getLanguageFontWithFallback(currentLang) }}>{t('apply.title')}</span>
        </PageTitle>
        <div className="apply-info-content">
          <div className="apply-info-section">
            <h2 className="apply-info-section-title">{t('apply.section1.title')}</h2>
            <div className="apply-info-list">
              <div className="apply-info-item">
                <span className="apply-info-item-number">{1}</span>
                <span className="apply-info-item-text">
                  {highlightText(t('apply.section1.item1'), t('apply.section1.item1.highlight'))}
                </span>
              </div>
              <div className="apply-info-item">
                <span className="apply-info-item-number">{2}</span>
                <span className="apply-info-item-text">
                  {highlightText(t('apply.section1.item2'), t('apply.section1.item2.highlight'))}
                </span>
              </div>
              <div className="apply-info-item">
                <span className="apply-info-item-number">{3}</span>
                <span className="apply-info-item-text">
                  {highlightText(t('apply.section1.item3'), t('apply.section1.item3.highlight'))}
                </span>
              </div>
            </div>
          </div>

          <div className="apply-info-section">
            <h2 className="apply-info-section-title">{t('apply.section2.title')}</h2>
            
            <div className="apply-info-subsection-list">
              <div className="apply-info-subsection">
                <h3 className="apply-info-subsection-title">{t('apply.section2.subsection1.title')}</h3>
                <div className="apply-info-list">
                  <div className="apply-info-item">
                    <span className="apply-info-item-number">{1}</span>
                    <span className="apply-info-item-text">{t('apply.section2.subsection1.item1')}</span>
                  </div>
                  <div className="apply-info-item">
                    <span className="apply-info-item-number">{2}</span>
                    <span className="apply-info-item-text">{t('apply.section2.subsection1.item2')}</span>
                  </div>
                  <div className="apply-info-item">
                    <span className="apply-info-item-number">{3}</span>
                    <span className="apply-info-item-text">{t('apply.section2.subsection1.item3')}</span>
                  </div>
                  <div className="apply-info-item">
                    <span className="apply-info-item-number">{4}</span>
                    <span className="apply-info-item-text">{t('apply.section2.subsection1.item4')}</span>
                  </div>
                </div>
              </div>

              <div className="apply-info-subsection">
                <h3 className="apply-info-subsection-title">{t('apply.section2.subsection2.title')}</h3>
                <div className="apply-info-list">
                  <div className="apply-info-item">
                    <span className="apply-info-item-number">{1}</span>
                    <span className="apply-info-item-text">{t('apply.section2.subsection2.item1')}</span>
                  </div>
                  <div className="apply-info-item">
                    <span className="apply-info-item-number">{2}</span>
                    <span className="apply-info-item-text">{t('apply.section2.subsection2.item2')}</span>
                  </div>
                  <div className="apply-info-item">
                    <span className="apply-info-item-number">{3}</span>
                    <span className="apply-info-item-text">{t('apply.section2.subsection2.item3')}</span>
                  </div>
                </div>
                <div className="apply-info-inquiry">
                  {(() => {
                    const email = t('apply.email');
                    const inquiryText = t('apply.inquiry');
                    const parts = inquiryText.split('{email}');
                    return (
                      <>
                        {parts[0]}
                        <a href={`mailto:${email}`} className="apply-info-email">
                          {email}
                        </a>
                        {parts[1] || ''}
                      </>
                    );
                  })()}
                </div>
                <div className="apply-info-disclaimer">
                  <span style={{ fontFamily: getLanguageFontWithFallback(currentLang) }}>
                    {t('apply.disclaimer')}
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div className="apply-info-button-container">
            <ArrowButton 
              text={t('apply.button')} 
              variant="special" 
              size="large"
              onClick={openApplicationForm}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default ApplyInfo;